/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Modal, Table, Button, Input, InputNumber, Space, message } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

let uid = 0;
const genId = () => `tmp_${Date.now()}_${uid++}`;

export const buildSummary = (rows) =>
  (rows || [])
    .map(
      (m) =>
        `${m.lot_name ? m.lot_name + " " : ""}${m.lot_size || 0}x${
          m.lot_price || 0
        }`
    )
    .join(", ");

export default function ModalSupplierLot({ open, close, record, value, confirm }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (open) {
      const init = (value && value.length ? value : []).map((m) => ({
        ...m,
        _rid: m._rid || (m.id ? `id_${m.id}` : genId()),
      }));
      setRows(init);
    }
  }, [open]);

  const handleClose = () => {
    close(false);
  };

  const handleAddRow = () => {
    setRows((r) => [
      ...r,
      { _rid: genId(), lot_name: "", lot_size: null, lot_price: null },
    ]);
  };

  const handleRemoveRow = (rid) => {
    setRows((r) => r.filter((m) => m._rid !== rid));
  };

  const handleChange = (rid, key, val) => {
    setRows((r) => r.map((m) => (m._rid === rid ? { ...m, [key]: val } : m)));
  };

  const handleConfirm = () => {
    const cleaned = rows.filter(
      (r) => r.lot_size !== null && r.lot_size !== undefined && r.lot_size !== ""
    );
    if (cleaned.length === 0) {
      message.warning("กรุณาเพิ่ม MOQ อย่างน้อย 1 รายการ");
      return;
    }
    const invalid = cleaned.some(
      (r) =>
        !r.lot_size ||
        r.lot_price === null ||
        r.lot_price === undefined ||
        r.lot_price === ""
    );
    if (invalid) {
      message.warning("กรุณากรอกขนาด MOQ และราคาให้ครบทุกแถว");
      return;
    }

    const payload = cleaned.map((m) => ({
      lot_name: m.lot_name || null,
      lot_size: m.lot_size,
      lot_price: m.lot_price,
    }));

    confirm(payload, buildSummary(cleaned));
    handleClose();
  };

  const columns = [
    {
      title: "ชื่อ MOQ",
      dataIndex: "lot_name",
      render: (v, row) => (
        <Input
          value={v}
          placeholder="เช่น ลังเล็ก"
          onChange={(e) => handleChange(row._rid, "lot_name", e.target.value)}
        />
      ),
    },
    {
      title: "ขนาด MOQ (จำนวน/MOQ)",
      dataIndex: "lot_size",
      width: 190,
      render: (v, row) => (
        <InputNumber
          style={{ width: "100%" }}
          value={v}
          min={0}
          placeholder="0"
          onChange={(val) => handleChange(row._rid, "lot_size", val)}
        />
      ),
    },
    {
      title: "ราคา/MOQ",
      dataIndex: "lot_price",
      width: 190,
      render: (v, row) => (
        <InputNumber
          style={{ width: "100%" }}
          value={v}
          min={0}
          placeholder="0"
          onChange={(val) => handleChange(row._rid, "lot_price", val)}
        />
      ),
    },
    {
      title: "",
      dataIndex: "operation",
      width: 50,
      align: "center",
      render: (_, row) => (
        <Button
          danger
          size="small"
          icon={<DeleteOutlined />}
          onClick={() => handleRemoveRow(row._rid)}
        />
      ),
    },
  ];

  return (
    <Modal
      open={open}
      title={`จัดการ MOQ การซื้อ${record?.stname ? " - " + record.stname : ""}`}
      onCancel={handleClose}
      afterClose={handleClose}
      maskClosable={false}
      width={700}
      footer={
        <Space>
          <Button onClick={handleClose}>ปิด</Button>
          <Button type="primary" onClick={handleConfirm}>
            บันทึก
          </Button>
        </Space>
      }
    >
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <Table
          bordered
          size="small"
          rowKey="_rid"
          dataSource={rows}
          columns={columns}
          pagination={false}
          locale={{ emptyText: "ยังไม่มี MOQ กรุณาเพิ่มข้อมูล" }}
        />
        <Button
          type="dashed"
          block
          icon={<PlusOutlined />}
          onClick={handleAddRow}
        >
          เพิ่ม MOQ
        </Button>
      </Space>
    </Modal>
  );
}
